import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';

@Component({
    selector: 'dic-action',
    templateUrl: './dic-action.component.html',
    styleUrls: ['./dic-action.component.scss'],
    standalone: false
})
export class DictionaryActionsComponent implements OnInit {

  constructor() { }

  eventsSubject: Subject<string> = new Subject<string>();
  parentRow:CardView = {};
  condition:string = '0=0'
  
  ngOnInit(): void {
  }
}
